import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import LoginButton from '../Auth/LoginButton';
import UserDropdown from '../Auth/UserDropdown';

const Header = ({ authToken, userInfo, assessmentsRemaining, monthlyLimit, onLogin, onLogout, view, onBack }) => {
  // Determine if we should show the back/home button
  const showBackButton = view && view !== 'home' && authToken;

  return (
    <header className="bg-teal-700 text-white h-16 fixed top-0 w-full z-10 shadow-md">
      <div className="h-full px-6 flex justify-between items-center">
        <div className="flex items-center gap-4">
          {showBackButton && (
            <button
              onClick={onBack}
              className="flex items-center gap-2 text-white hover:bg-teal-600 px-3 py-2 rounded-lg transition-colors"
              title="Go to home"
            >
              <Home size={20} />
              <span className="font-medium">Home</span>
            </button>
          )}
          <h1 className="text-xl font-semibold">Clinical Docs</h1>
        </div>
        <div className="flex items-center gap-4">
          {authToken ? (
            <UserDropdown
              userInfo={userInfo}
              assessmentsRemaining={assessmentsRemaining}
              monthlyLimit={monthlyLimit}
              onLogout={onLogout}
            />
          ) : (
            <LoginButton onClick={onLogin} />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;

